/**
 * External Dependencies
 */
import Controller from './helpers/Controller';

import common from './controllers/common';
import Accordeon from './components/Accordeon';
import AlertComponent from './components/AlertComponent';
import BannerComponent from './components/BannerComponent';
import Slick from './components/Slick';
import NewsFilter from './components/NewsFilter';
import Nav from './components/Nav';
import CursorComponent from './components/CursorComponent';
import Menu from './components/Menu';
import Rellax from './components/Rellax';
import CardTenders from './components/CardTenders';
import Logos from './components/Logos';
import Map from './components/Map';
import Numbers from './components/Numbers';
import NewsDropdownFilters from './components/NewsDropdownFilters';

const modules = [
    common,
    Accordeon,
    AlertComponent,
    BannerComponent,
    Slick,
    NewsDropdownFilters,
    NewsFilter,
    Nav,
    CursorComponent,
    Menu,
    Numbers,
    Rellax,
    CardTenders,
    Logos,
    Map
];
const controller = new Controller(modules);
controller.ready();

// @note - this will popup a confirmation before leaving the page
// window.onbeforeunload = () => controller.destroy();
